/* eslint-disable */
// @ts-nocheck

/* eslint-enable prettier/prettier */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable import/no-unresolved */

/* global I18n */

// i18n-tasks-use t('frontend.submit_question')
// i18n-tasks-use t('questions.error_submitting')

import React, { useEffect, useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import useFocus from "@untyped-components/hooks/useFocus";
import QuestionService from "../services/questionService";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import AuthorField from "./authorField";
import TextField from "./textField";

import { useSelector, useDispatch } from "react-redux";
import {
  selectAnonymousQuestions,
  selectMandatoryName,
} from "@untyped-store/selectors/activeEvent";

import { createQuestion } from "@untyped-store/slices/questionsSlice";

import { selectSelectedRoom } from "@untyped-store/slices/questionRoomsSlice";

import { useLocalize } from "../../../i18nProvider";

const useStyles = makeStyles((theme) => ({
  boxSuccess: {
    border: "1px solid #3c763d",
  },
  boxSuccessDisable: {
    border: "1px solid #3c763d",
    backgroundColor: "#EEEEEE",
  },
  boxErrorDisable: {
    border: "1px solid #a94442",
    backgroundColor: "#EEEEEE",
  },
  boxError: {
    border: "1px solid #a94442",
  },
  privacyNote: {
    fontSize: "1.2rem",
    marginTop: "4px",
  },
  flexContainer: {
    display: "flex",
    gap: "6px",
  },
  btn: {
    textTransform: "none",
    fontSize: "1.2rem",
    maxHeight: 31,
    color: "#fff !important",
    backgroundColor: "#594f8d",
    borderColor: "#594f8d",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#594f8d",
      borderColor: "#594f8d",
      boxShadow: "none",
    },
    "&:focus": {
      outlineColor: "#ffff",
      outlineOffset: "-6px",
      outlineStyle: "solid",
      outlineWidth: "3px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.1rem",
    },
  },
}));

function FormQuestionVertical() {
  const classes = useStyles();
  const service = new QuestionService();
  const config = service.getConfigForm();
  const anonymousQuestions = useSelector(selectAnonymousQuestions);
  const mandatoryName = useSelector(selectMandatoryName);
  const dispatch = useDispatch();

  const maxLength = config.maxLengthQuestion * 1;
  const [disable, setDisable] = useState(false);
  const [inputRef, setInputFocus] = useFocus();
  const [authorName, setAuthorName] = useState(config.defaultName);
  const [textQuestion, setTextQuestion] = useState("");
  const [authorStyle, setAuthorStyle] = useState("");
  const [authorError, setAuthorError] = useState(false);
  const [submissionErrorForSR, setSubmissionErrorForSR] = useState(false);
  const [submissionSuccessForSR, setSubmissionSuccessForSR] = useState(false);
  const [textStyle, setTextStyle] = useState("");
  const [dynamicLength, setDynamicLength] = useState(maxLength);
  const questionRoom = useSelector(selectSelectedRoom);
  const [questionHasBeenFocused, setQuestionHasBeenFocused] = useState(false);

  const handlerClick = (e) => {
    e.preventDefault();
    const authorValid = getAuthor(authorName);
    const textValid = getText(textQuestion);
    if (config.event_check && authorValid && textValid) {
      setDisable(true);
      addQuestion();
      setAuthorStyle(classes.boxSuccessDisable);
      setTextStyle(classes.boxSuccessDisable);
      setSubmissionSuccessForSR(true);
      clearStyles();
      setQuestionHasBeenFocused(false);
    } else {
      setSubmissionErrorForSR(true);
      clearStyles();
    }
  };

  const clearStyles = () => {
    setTimeout(() => {
      setDisable(false);
      setAuthorStyle("");
      setTextStyle("");
      setSubmissionErrorForSR(false);
      setSubmissionSuccessForSR(false);
    }, 3000);
  };

  const checkEnter = (value) => {
    getAuthor(value);
    setInputFocus();
  };

  const addQuestion = () => {
    const newQuestion = {
      message: textQuestion,
      attendee_id: config.attendeeId,
      chat_room_id: questionRoom.id,
      publishing_name: authorName,
    };

    dispatch(createQuestion({ question: newQuestion }));

    setTextQuestion("");
    setDynamicLength(maxLength);
  };

  const getAuthor = (value, updateStyle = true) => {
    if (anonymousQuestions) {
      setAuthorName("Anonymous");
      if (updateStyle) {
        setAuthorStyle(classes.boxSuccess);
        setAuthorError(false);
      }
      return true;
    }
    if (mandatoryName && !value) {
      setAuthorName("");
      if (updateStyle) {
        setAuthorStyle(classes.boxError);
        setAuthorError(true);
      }
      return false;
    }
    setAuthorName(value);
    if (updateStyle) {
      setAuthorStyle(classes.boxSuccess);
      setAuthorError(false);
    }
    return true;
  };

  const getText = (value) => {
    if (!value.trim()) {
      setTextQuestion("");
      setTextStyle(classes.boxError);
      return false;
    }
    setTextQuestion(value);
    setTextStyle(classes.boxSuccess);
    return true;
  };

  const handleAuthorFocus = () => {
    if (authorStyle) {
      setAuthorStyle("");
    }
  };

  const handleTextFocus = () => {
    if (authorStyle) {
      setTextStyle("");
    }
  };

  useEffect(() => {
    getAuthor(authorName, false);
  }, [anonymousQuestions, mandatoryName]);

  return (
    <div id="ask_your_q" className="card w-100 form-group">
      <div className="card-body">
        <h2 id="ask_question_header" className="sr-only">
          {useLocalize("frontend.submit_question")}
        </h2>
        <form aria-labelledby="ask_question_header">
          {!anonymousQuestions && (
            <AuthorField
              isRequired={mandatoryName}
              hasError={authorError}
              name="authorQuestion"
              authorLabel={config.authorLabel}
              authorName={authorName}
              styles={authorStyle}
              disable={disable || config.preventChangingAuthorName}
              onFocus={handleAuthorFocus}
              callKeyDown={checkEnter}
              callback={getAuthor}
            />
          )}
          <TextField
            name="textQuestion"
            id="textQuestion"
            textLabel={config.textLabel}
            textPlaceholder={config.textPlaceholder}
            text={textQuestion}
            styles={textStyle}
            lengthValue={dynamicLength}
            onFocus={handleTextFocus}
            ref={inputRef}
            disable={disable}
            callback={getText}
            hasBeenFocused={questionHasBeenFocused}
            setHasBeenFocused={setQuestionHasBeenFocused}
          />
          <Button
            variant="contained"
            className={`${classes.btn} submit-question`}
            disabled={disable || !questionRoom}
            onClick={handlerClick}
            disableRipple
          >
            {useLocalize("submit")}
          </Button>
          <p
            className={classes.privacyNote}
            dangerouslySetInnerHTML={{
              __html: I18n.t("questions.privacy_note", {
                privacy_policy_link: useLocalize(
                  "frontend.privacy_policy_link",
                ),
              }),
            }}
          />
          {submissionSuccessForSR && (
            <div className={classes.flexContainer}>
              <CheckCircleIcon fontSize="small" htmlColor="#3c763d" />
              <p role="alert">
                {useLocalize("questions.submit_success_message")}
              </p>
            </div>
          )}
          {submissionErrorForSR && (
            <span className="sr-only" role="alert">
              {useLocalize("questions.error_submitting")}
              {authorError && useLocalize("questions.name_required")}
              {textQuestion.length === 0 &&
                useLocalize("questions.question_required")}
            </span>
          )}
        </form>
      </div>
    </div>
  );
}

export default FormQuestionVertical;
